export const CONNECT = 'CONNECT'